module.exports = __webpack_public_path__ + "img/63157ebaf909da6c173b9569b6b1402e.png";